// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1pcfm","additionalInfo":"AgreementModal_additionalInfo__2HP3k"};